// NOTE: legacy, replace with format-coins.ts
export const formatCurrency = (value: number) =>
  value.toLocaleString('uk-UA', { style: 'currency', currency: 'UAH' });
